import React from 'react';

const PortfolioContext = React.createContext(); // Export this context

export default PortfolioContext;
